import { Injectable } from '@angular/core';
import { ProxyHttpService } from "app/shared/proxy-http/proxy-http.service";
import { Utils } from 'app/shared/utility/utils';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environments-service/environments-service';

declare var window: any;

@Injectable()
export class CmsService extends ProxyHttpService {

  public headerLogo = 'assets/res/img/logo.svg';
  public headerClaimLogo = "assets/res/img/logo-claim.png";
  public headerFindoFormLogo: string = null;
  public headerClaimFormLogo: string = null;
  public headerPartnerLogo: string = null;
  
  // BCD-648
  private readonly divTrackElement: any;

  constructor(
    http: HttpClient,
    $e: EnvironmentService
  ) {
    super(http, $e);
    this.divTrackElement = document.getElementById("divEventHolder");
  }

  // BCD-648
  public trackNEW(customEv, data?: any) {
    window.dLayer = this.init_dLayer(data);
    this.dispatchEventTrack(customEv, false);
  }

  // BCD-648
  init_dLayer(data?) {
    let tvei = "";
    // MOBILE SITE
    if((typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)) {
      tvei = "1003360328";
    }
    // WEB
    else {
      tvei = "1003001344";
    }

    return {
      "pageName": "area-pubblica:dove-siamo:atm",
      "dat_brows": this.get_dat_brows(),
      "content_type": "altro",
      "topic": "altro",
      "site_section": "dove-siamo",
      "site_subsection": "atm",
      "contesto": "area-pubblica",
      "regione": data ? data.region : null,
      "provincia": data ? data.province : null,
      "id_lead": undefined,
      "tvei": tvei,
      "ndg": undefined,
      "isVirtual": false,
      "currencyCode": undefined,
      "cid": undefined,
      "is_app": false,
      "app_version": undefined,
      "product_name": undefined,
      "service_name": "trova-atm",
      "step_name": undefined,
      "step_number": undefined,
      "id_pratica": undefined,
      "id_piano_finanziario": undefined,
    };
  }

  // BCD-648
  dispatchEventTrack(operationLabel: string, initDLayer = false) {
    if(initDLayer) {
      window.dLayer = this.init_dLayer();
    }

    const event = document.createEvent('CustomEvent');
    event.initCustomEvent(operationLabel, false, false, undefined);

    if(!Utils.isEmptyValue(this.divTrackElement)) {
      this.fireTrackEvent(event);
    }
  }

  // [INC7455755]
  fireTrackEvent(event) {
    if(window.AppMeasurement) {
      this.divTrackElement.dispatchEvent(event);
    }
    else {
      setTimeout(() => {
        this.fireTrackEvent(event);
      }, 100);
    }
  }

  getSecureRandomNumber(){
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    return array[0];
    
  }
  
  get_dat_brows(): any {
    let datbrows: any = '';
    datbrows = window.sessionStorage.getItem('dat_brows');

    if(Utils.isEmptyValue(datbrows)) {
      datbrows = '';
      const possibleChars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      for(let i=0; i<27; i++) {
        datbrows += possibleChars.charAt(Math.floor(this.getSecureRandomNumber() * possibleChars.length));
      }
      window.sessionStorage.setItem('dat_brows', datbrows);
    }
    let timestamp = Date.now();
    timestamp += datbrows;

    return timestamp;
  }

}
